// eslint-disable-next-line import/prefer-default-export
export function buildGazeboUiUri(s3Uri: string) {
  const gazeboUiBaseUrl = process.env.REACT_APP_GAZEBO_UI_URL;
  if (gazeboUiBaseUrl === undefined) {
    throw new Error('process.env.REACT_APP_GAZEBO_UI_URL is not defined');
  }
  return `${gazeboUiBaseUrl}?s3Uri=${encodeURIComponent(s3Uri)}`;
}
